import styled from 'styled-components';
import { getScreenMaxWidth } from '../../utils/bundle.esm3.js';

const MaxWidthStyled = styled.div`
  --max: min(
    ${(props) => props.maxSize + props.minPadding * 2}px,
    ${getScreenMaxWidth}
  );

  margin: 0 auto;
  max-width: var(--max);
  min-width: min(var(--max), ${(props) => props.stretch ? 100 : 0}%);
  position: relative;
  display: inherit;

  .MaxWidth {
    &__inner {
      padding: 0 ${(props) => props.minPadding}px;
      min-width: ${(props) => props.stretch ? 100 : 0}%;
      position: relative;
      display: inherit;
    }
  }
`;

export { MaxWidthStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
